import { render, staticRenderFns } from "./ChatWithHiva.vue?vue&type=template&id=550b71a6&scoped=true&"
import script from "./ChatWithHiva.vue?vue&type=script&lang=js&"
export * from "./ChatWithHiva.vue?vue&type=script&lang=js&"
import style0 from "./ChatWithHiva.vue?vue&type=style&index=0&id=550b71a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b71a6",
  null
  
)

export default component.exports